/**
 * App shell chrome — Figma `5037:6405` / `5037:6426` (Header).
 * Instrument workspace pages (builder, routing) use **32dp** in their own bleed wrappers.
 */
export const APP_SHELL_HEADER_HEIGHT_PX = 85

/** Horizontal inset for non-workspace headers (create flow). Workspace routes use `instrumentWorkspaceRailBoxSx`. */
export const APP_SHELL_HEADER_PADDING_X_PX = 32

/** Figma `I5037:6405;57:2014` — `pt-[16px] px-[32px]`. */
export const APP_SHELL_HEADER_PADDING_TOP_PX = 16

/** Inner toolbar row height (`57:2002`). */
export const APP_SHELL_HEADER_ROW_HEIGHT_PX = 52

export const APP_SHELL_HEADER_PADDING_BOTTOM_PX =
  APP_SHELL_HEADER_HEIGHT_PX -
  APP_SHELL_HEADER_PADDING_TOP_PX -
  APP_SHELL_HEADER_ROW_HEIGHT_PX

/** Figma sidebar (`4107:1270`) — persistent from `md` up; drawer below `md`. */
export const APP_SHELL_SIDEBAR_WIDTH_PX = 256

/** MUI breakpoint key: nav rail is persistent at this width and above. */
export const APP_SHELL_NAV_PERSISTENT_BREAKPOINT = 'md' as const
